import {
  Box,
  Card,
  CardContent,
  Divider,
  SxProps,
  Typography,
  Skeleton,
} from '@mui/material';

interface StatisticBentoProps {
  allValue?: number;
  previousValue?: number;
  activeValue?: number;
  sx?: SxProps;
  isLoading?: boolean;
}

export const StatisticBento: React.FC<StatisticBentoProps> = ({
  allValue,
  previousValue,
  activeValue,
  sx,
  isLoading,
}) => {
  const formatValue = (value?: number) => {
    if (!value) return '0';

    return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        zIndex: 1,
        ...sx,
      }}
    >
      <Box sx={{ ml: 1 }}>
        <Typography variant="caption" color="inherit">
          All
        </Typography>
        <Typography variant="h4" color="inherit">
          {isLoading ? <Skeleton variant="text" width={100} /> : formatValue(allValue)}
        </Typography>
      </Box>
      <Divider
        orientation="vertical"
        sx={{ mx: 2, my: 'auto', height: '25px' }}
      />
      <Box>
        <Typography variant="caption" color="inherit">
          Last Month
        </Typography>
        <Typography variant="h4" color="inherit">
          {isLoading ? <Skeleton variant="text" width={100} /> : formatValue(previousValue)}
        </Typography>
      </Box>
      <Divider
        orientation="vertical"
        sx={{ mx: 2, my: 'auto', height: '25px' }}
      />
      <Box sx={{ mr: 1 }}>
        <Typography variant="caption" color="inherit">
          Current Month
        </Typography>
        <Typography variant="h4" color="inherit">
          {isLoading ? <Skeleton variant="text" width={100} /> : formatValue(activeValue)}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatisticBento;
